export default {
  baseApiUrl: 'https://api.cluj.taxi',
  wsUrl: 'wss://ws.cluj.taxi',
  wsApiUrl: 'https://ws.cluj.taxi',
  googleMapsApiKey: 'AIzaSyCUpdvHdasu5RZ3Sbg0olLI-UKLhlD9bpw',
  userAddressesUrl: 'https://user-addresses.cluj.taxi',
  mapCenter: { lat: 47.151726, lng: 27.587914 },
  addrApiUrl: 'https://addr.cluj.taxi',
  addrApiUrlNew: 'https://places-1.ogo.taxi'
}
